// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"dffc0594","117":"827bb133","118":"9464425b","168":"815a1573","211":"c05fde43","219":"8d2d7367","229":"655ba65f","259":"7191a87e","477":"47c89dd4","586":"b0274e2f","632":"5e68d7db","819":"de85900e","845":"f3f755b4","927":"f9ec56be","930":"d7fd650f","960":"8e0e24d3"}[chunkId] + ".chunk.js";
};